"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SelectableUI = _interopRequireDefault(require("../../SelectableUI"));
var _Image = _interopRequireDefault(require("../../Image"));
var __jsx = _react["default"].createElement;
var defaultProps = {
  borderColor: "black",
  borderWidth: 1
};
var ColorSquare = function ColorSquare(props) {
  var _props$roundness = props.roundness,
    roundness = _props$roundness === void 0 ? true : _props$roundness,
    imageSize = props.imageSize,
    _props$borderColor = props.borderColor,
    borderColor = _props$borderColor === void 0 ? defaultProps.borderColor : _props$borderColor,
    _props$borderWidth = props.borderWidth,
    borderWidth = _props$borderWidth === void 0 ? defaultProps.borderWidth : _props$borderWidth;
  var additionalStyles = {
    borderRadius: roundness ? "50px" : 0,
    padding: roundness ? "5px" : 0
  };
  return __jsx(_SelectableUI["default"], (0, _extends2["default"])({}, props, {
    containerAdditionalStyles: {
      height: imageSize !== null && imageSize !== void 0 ? imageSize : [62, null, null, 64],
      width: imageSize !== null && imageSize !== void 0 ? imageSize : [62, null, null, 64]
    }
  }), function (_ref) {
    var _props$option;
    var highlighted = _ref.highlighted,
      selected = _ref.selected;
    return ((_props$option = props.option) === null || _props$option === void 0 ? void 0 : _props$option.image) && __jsx(_Image["default"], {
      image: props.option.image,
      cloudflareEnabled: global.__appConfig__.swatchesImageCloudflareEnabled,
      quality: global.__appConfig__.swatchesImageQuality,
      minified: true,
      highlighted: highlighted,
      selected: selected,
      roundness: roundness,
      additionalStyles: additionalStyles,
      borderColor: borderColor,
      borderSpace: imageSize > 0,
      borderWidth: borderWidth
    });
  });
};
var _default = ColorSquare;
exports["default"] = _default;